
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Pleurisy(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Pleurisy(pleuritis)"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Pleurisy is a condition in which the pleura — two
                                    large, thin layers of tissue that separate your
                                    lungs from your chest wall — <b>becomes
                                    inflamed.</b> Also called pleuritis, pleurisy causes
                                    sharp chest pain (pleuritic pain) that worsens
                                    during breathing.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Pleurisy(pleuritis)/1.png")} alt="Pleurisy(pleuritis)" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p>The defining symptom of pleurisy is a sudden sharp, stabbing, burning or dull pain in the right or left side of the chest during breathing, especially when one inhales and exhales.</p>
                                <ul className="listUnstyle">
                                    <li>
                                        <p>
                                            <b>Pain areas: </b>
                                            <br />
                                            in the side part of the body
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Pain circumstances:</b>
                                            <br />
                                            can occur in the chest while breathing
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Respiratory:</b>
                                            <br />
                                            fast breathing, shallow breathing, or shortness of breath
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Also common:</b>
                                            <br />
                                            dry cough or fever
                                        </p>
                                    </li>

                                </ul>
                                <a className="links" href="https://en.wikipedia.org/wiki/Pleurisy">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Pleurisy;